// Phase 8 — gate every non-login route behind an authenticated session.
//
// Three states from useAuth():
//   • user === null  → still checking; render a soft loader (no flicker)
//   • user === false → definitely anonymous; redirect to /login?next=...
//   • user === obj   → let the child through
//
// The `?next=` query is picked up by Login.jsx to bounce the user
// back to the page they tried to reach — bookmarkable deep links
// work as expected.

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-sm text-muted-foreground"
        data-testid="auth-checking"
      >
        Signing you in…
      </div>
    );
  }
  if (user === false) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
